import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import { INITIAL_STATE } from '../../../../common/constants/state';
import { SELECT_SOURCE_STEP } from '../../../../common/constants/steps';
import type { State } from '../../../../common/types';

export type ResetStateAction = () => Action<State, void, void>;

export const resetState =
	() =>
	({ setState }: StoreActionApi<State>) => {
		setState({
			...INITIAL_STATE,
			step: SELECT_SOURCE_STEP,
		});
	};
